module.exports = __webpack_public_path__ + "img/iconLiangNew.6cb1f419.png";